import React, {Component} from 'react';
import {FaCheckCircle, FaShoppingBasket} from "react-icons/fa";
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col} from 'reactstrap';

class DetailProductVpsComponent extends Component {

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    changeBillingCycle = (actionKey, billing) => {
        // console.log("da den")
        this.props.changeBillingCycle( actionKey, billing );
    }

    loadCyclePrice = (product, actionKey) => {
        return (
            <li>
                <button type="button" className="text-secondary">{ product.text_pricing }đ / { product.text_billing_cycle }</button>
                <ul className="submenu-flip">
                    {/* 1 thang */}
                    {
                        product.product_pricing.monthly ? (
                            <>
                                {
                                    product.chosseBillcycle ===  'monthly' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.monthly ) }đ
                                            <small className="d"> / 1 Tháng</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'monthly' ) }>
                                            { this.addCommas( product.product_pricing.monthly ) }đ
                                            <small className="d"> / 1 Tháng</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {/* 2 thang */}
                    {
                        product.product_pricing.twomonthly ? (
                            <>
                                {
                                    product.chosseBillcycle ===  'twomonthly' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.twomonthly ) }đ
                                            <small className="d"> / 2 Tháng</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'twomonthly' ) }>
                                            { this.addCommas( product.product_pricing.twomonthly ) }đ
                                            <small className="d"> / 2 Tháng</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {/* 3 thang */}
                    {
                        product.product_pricing.quarterly ? (
                            <>
                                {
                                    this.props.product.chosseBillcycle ===  'quarterly' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.quarterly ) }đ
                                            <small className="d"> / 3 Tháng</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'quarterly' ) }>
                                            { this.addCommas( product.product_pricing.quarterly ) }đ
                                            <small className="d"> / 3 Tháng</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {/* 6 thang */}
                    {
                        product.product_pricing.semi_annually ? (
                            <>
                                {
                                    product.chosseBillcycle ===  'semi_annually' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.semi_annually ) }đ
                                            <small className="d"> / 6 Tháng</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'semi_annually' ) }>
                                            { this.addCommas( product.product_pricing.semi_annually ) }đ
                                            <small className="d"> / 6 Tháng</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {/* 1 nam */}
                    {
                        product.product_pricing.annually ? (
                            <>
                                {
                                    product.chosseBillcycle ===  'annually' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.annually ) }đ
                                            <small className="d"> / 1 Năm</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'annually' ) } >
                                            { this.addCommas( product.product_pricing.annually ) }đ
                                            <small className="d"> / 1 Năm</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {/* 2 Năm */}
                    {
                        product.product_pricing.biennially ? (
                            <>
                                {
                                    product.chosseBillcycle ===  'biennially' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.biennially ) }đ
                                            <small className="d"> / 2 Năm</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'biennially' ) }>
                                            { this.addCommas( product.product_pricing.biennially ) }đ
                                            <small className="d"> / 2 Năm</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {/* 3 nam */}
                    {
                        product.product_pricing.triennially ? (
                            <>
                                {
                                    product.chosseBillcycle ===  'triennially' ? (
                                        <li className="closed li-pricing active">
                                            { this.addCommas( product.product_pricing.triennially ) }đ
                                            <small className="d"> / 3 Năm</small>
                                        </li>
                                    ) : (
                                        <li className="closed li-pricing" onClick={ () => this.props.changeBillingCycle( actionKey, 'triennially' ) }>
                                            { this.addCommas( product.product_pricing.triennially ) }đ
                                            <small className="d"> / 3 Năm</small>
                                        </li>
                                    )
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                </ul>
            </li>
        )
    }

    render() {
        
        return (
            <Col xl={3} lg={4} sm={6} className="mb-4">
                <Card className="h-100">
                    <CardHeader className="text-primary font-weight-bold text-center">
                        { this.props.product.name }
                         <ul className="menu-flip text-capitalize mt-2">
                            
                            {/* Vĩnh viễn */}
                            {
                                this.props.product.product_pricing.type === 'one_time' ? (
                                    <li>
                                        <button type="button" className="text-secondary">
                                            { this.addCommas( this.props.product.product_pricing.one_time_pay ) }đ <small className="d"> / Vĩnh viễn</small>
                                        </button>
                                    </li>
                                ) : (
                                        this.loadCyclePrice(this.props.product, this.props.actionKey) 
                                )
                            }
                        </ul>
                    </CardHeader>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item"><FaCheckCircle className="text-success disabled" /> CPU: { this.props.product.product_detail.cpu } core</li>
                        <li className="list-group-item"><FaCheckCircle className="text-success" /> Memory: { this.props.product.product_detail.ram } GB</li>
                        <li className="list-group-item"><FaCheckCircle className="text-success" /> Disk SSD: { this.props.product.product_detail.disk } GB</li>
                        {
                            this.props.product.type === 'VPS-GPU' ? (
                                <li className="list-group-item"><FaCheckCircle className="text-success" /> GPU: { this.props.product.product_detail.gpu } GPU</li>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.props.product.type === 'NAT-VPS' ? (
                                <li className="list-group-item"><FaCheckCircle className="text-success" /> IP: { this.props.product.product_detail.ip } IP NAT</li>
                            ) : (
                                <li className="list-group-item"><FaCheckCircle className="text-success" /> IP: { this.props.product.product_detail.ip } IP public</li>
                            )
                        }
                        <li className="list-group-item"><FaCheckCircle className="text-success" /> Băng thông: { this.props.product.product_detail.bandwidth }</li>
                        <li className="list-group-item"><FaCheckCircle className="text-success" /> Hệ điều hành: { this.props.product.product_detail.os }</li>
                    </ul>
                    <CardBody className="text-center pb-1">
                        <Link 
                            className="btn btn-primary"
                            to={"/dat-hang/vps/" + this.props.product.id + "/" + this.props.product.chosseBillcycle + '/don-dat-hang-tao-vps.html'}
                        >
                            <FaShoppingBasket /> Mua ngay
                        </Link>
                    </CardBody>
                </Card>
                
            </Col>
        )
    }
}

export default DetailProductVpsComponent;